import React from "react";

const MetricCards = ({ overview }) => (
    <div className="grid grid-cols-2 md:grid-cols-5 gap-4 mb-8">
        <div className="flex flex-col items-center justify-center rounded-xl shadow bg-white p-4">
            <span className="text-black text-xl font-bold">₱{(overview.today ?? 0).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</span>
            <span className="text-xs text-gray-500 mt-1">Today</span>
        </div>
        <div className="flex flex-col items-center justify-center rounded-xl shadow bg-white p-4">
            <span className="text-black text-xl font-bold">₱{(overview.week ?? 0).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</span>
            <span className="text-xs text-gray-500 mt-1">Week</span>
        </div>
        <div className="flex flex-col items-center justify-center rounded-xl shadow bg-white p-4">
            <span className="text-black text-xl font-bold">₱{(overview.month ?? 0).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</span>
            <span className="text-xs text-gray-500 mt-1">Month</span>
        </div>
        <div className="flex flex-col items-center justify-center rounded-xl shadow bg-white p-4">
            <span className="text-black text-xl font-bold">{(overview.orders ?? 0).toLocaleString()}</span>
            <span className="text-xs text-gray-500 mt-1">Orders</span>
        </div>
        <div className="flex flex-col items-center justify-center rounded-xl shadow bg-white p-4">
            <span className="text-black text-xl font-bold">₱{(overview.avg ?? 0).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</span>
            <span className="text-xs text-gray-500 mt-1">Avg Order</span>
        </div>
    </div>
);

export default MetricCards;
